import {AiToolImpl} from "@me8eon/aiclient";
import {filterGraphApiPeopleHits} from "./model/filters";
import {mapGraphApiHitsToString} from "./model/mappers";
import {postGraphApi} from "../model/api";
import { JwtTokenFn } from "@me8eon/authentication";

type ToolArgs = {
    query: string
}


type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (tokenFn: JwtTokenFn) => ToolImpl

type Executor = (tokenFn: JwtTokenFn) => ToolImpl['execute']


const executor: Executor = (tokenFn) => async (_args, input) => {
    const {query} = input;

    const body = {
        "requests": [
            {
                "entityTypes": ["people"],
                "query": {
                    "queryString": `${query.trim()}`,
                },
                "selectProperties": [
                    "displayName",
                    "jobTitle",
                    "mobilePhone",
                    "businessPhones",
                    "aboutMe",
                    "hitHighlightedSummary",
                ],
            },

        ],
    }

    const response = await postGraphApi(body, tokenFn)

    const hits = response.data.value?.[0]?.hitsContainers?.[0]?.hits || [];
    if (hits.length === 0) return {
        value: "No people found."
    }

    const filtered = filterGraphApiPeopleHits(hits)

    const mappedToString = mapGraphApiHitsToString(filtered);

    return {
        value: `Here are the people found:\n\n${mappedToString}`
    }
}

export const SearchPeopleToolImplGenerator: Tool = (tokenFn) => {
    return {
        type: "graph_api",
        toolDefn: {
            type: 'function',
            name: "search_people",
            description: "This tool fetches people ONLY by their name/surname from GraphAPI platform. It returns a list of people matching the search query. If no people are found, it returns 'No people found.'.",
            parameters: {
                type: "object",
                required: ["query"],
                additionalProperties: false,
                properties: {
                    query: {
                        type: "string",
                        description: "The search query to find people.",
                    }
                },
            },
        },
        execute: executor(tokenFn),
    }
}